const ENVIRONMENT_LABELS: Readonly<Record<string, "dev" | "prod" | "local">> = {
  dev: "dev",
  development: "dev",
  local: "local",
  prod: "prod",
  production: "prod",
};

/** A release is identified by its commit: forty hex characters, of which seven are shown. */
const COMMIT = /^[0-9a-f]{7,40}$/;

/**
 * The environment and the release the portal is serving, for the one line in the user menu.
 *
 * `release` is the commit the delivery ledger recorded for this release. On dev it arrived as
 * the workload fingerprint instead — a `sha256:…` digest — and the first seven characters of
 * that are the literal text "sha256:", so the line read `dev · sha256:` on every release and
 * identified nothing (W8-UI-10). A value that is not a commit identifies no build, so the line
 * is not drawn at all rather than shown as a label a reader cannot use.
 */
export function productVersionLabel(environment: string, release: string): string | null {
  const environmentLabel = ENVIRONMENT_LABELS[environment.trim().toLowerCase()];
  const releaseIdentity = release.trim().toLowerCase();
  if (environmentLabel === undefined || !COMMIT.test(releaseIdentity)) return null;

  return `${environmentLabel} · ${releaseIdentity.slice(0, 7)}`;
}
